import { StyleSheet, Platform, Dimensions } from 'react-native';
import { Theme } from '../../components/ui';

const { width: SCREEN_WIDTH } = Dimensions.get('window');

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#FFFFFF',
  },
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: Theme.colors.background,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: Theme.spacing.md,
    paddingVertical: Theme.spacing.sm,
    backgroundColor: 'rgba(255,255,255,0.98)',
    borderBottomWidth: 1,
    borderBottomColor: 'rgba(0,0,0,0.06)',
    ...Platform.select({
      ios: { paddingTop: 50 },
      android: { paddingTop: Theme.spacing.lg },
      web: { paddingTop: Theme.spacing.lg },
    }),
  },
  headerButton: {
    width: 44,
    height: 44,
    borderRadius: 22,
    justifyContent: 'center',
    alignItems: 'center',
  },
  progressContainer: {
    flex: 1,
    flexDirection: 'row',
    gap: 4,
    marginHorizontal: Theme.spacing.md,
  },
  progressSegment: {
    flex: 1,
    height: 3,
    backgroundColor: '#e5e7eb',
    borderRadius: 2,
    overflow: 'hidden',
  },
  progressSegmentActive: {
    height: 4,
  },
  progressSegmentFill: {
    height: '100%',
    width: '100%',
    opacity: 0.3,
  },
  progressSegmentFillActive: {
    opacity: 1,
  },
  navArrows: {
    position: 'absolute',
    bottom: 140,
    left: 0,
    right: 0,
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingHorizontal: Theme.spacing.md,
    zIndex: 100,
  },
  navArrow: {
    width: 48,
    height: 48,
    borderRadius: 24,
    backgroundColor: '#fff',
    justifyContent: 'center',
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.2,
    shadowRadius: 12,
    elevation: 6,
    borderWidth: 1,
    borderColor: 'rgba(0,0,0,0.1)',
  },
  navArrowLeft: {
    marginRight: 'auto',
  },
  navArrowRight: {
    marginLeft: 'auto',
  },
  navArrowHidden: {
    opacity: 0,
    pointerEvents: 'none',
  },
  pagesContainer: {
    flexDirection: 'row',
    flex: 1,
  },
  flatListContainer: {
    flex: 1,
  },
  pageContainer: {
    width: SCREEN_WIDTH,
    flex: 1,
  },
  page: {
    flex: 1,
  },
  scrollView: {
    flex: 1,
  },
  scrollContent: {
    padding: Theme.spacing.xl,
  },
  titleSection: {
    marginBottom: Theme.spacing.xl,
  },
  badge: {
    alignSelf: 'flex-start',
    paddingHorizontal: Theme.spacing.md,
    paddingVertical: 6,
    backgroundColor: Theme.colors.surfaceSecondary,
    borderRadius: Theme.borderRadius.sm,
    marginBottom: Theme.spacing.md,
  },
  badgeText: {
    fontSize: 12,
    color: Theme.colors.textSecondary,
    fontFamily: Theme.typography.fontFamily.medium,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  title: {
    fontSize: 28,
    fontFamily: Theme.typography.fontFamily.semiBold,
    fontWeight: '600',
    color: Theme.colors.textPrimary,
    lineHeight: 36,
    marginBottom: Theme.spacing.sm,
  },
  subtitle: {
    fontSize: 14,
    color: Theme.colors.textTertiary,
    lineHeight: 20,
    fontFamily: Theme.typography.fontFamily.regular,
  },
  playButtonContainer: {
    alignItems: 'center',
    marginBottom: Theme.spacing.xl,
  },
  playButton: {
    borderRadius: Theme.borderRadius.lg,
    overflow: 'hidden',
    maxWidth: 300,
    width: '100%',
    backgroundColor: '#fff',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.15,
    shadowRadius: 12,
    elevation: 4,
  },
  playGradient: {
    height: 56,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: Theme.spacing.sm,
    paddingHorizontal: Theme.spacing.xl,
  },
  playText: {
    fontSize: 17,
    fontFamily: Theme.typography.fontFamily.semiBold,
    color: '#fff',
    fontWeight: '600',
  },
  contentText: {
    color: Theme.colors.textPrimary,
    marginBottom: Theme.spacing.xl,
  },
  widgetCardShadow: {
    backgroundColor: 'transparent',
    borderRadius: Theme.borderRadius.xl,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.08,
    shadowRadius: 12,
    elevation: 3,
    marginBottom: Theme.spacing.xl,
  },
  widgetCard: {
    backgroundColor: Theme.colors.surface,
    borderRadius: Theme.borderRadius.xl,
    padding: Theme.spacing.xl,
  },
  widgetHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: Theme.spacing.md,
    marginBottom: Theme.spacing.lg,
  },
  widgetIconCircle: {
    width: 44,
    height: 44,
    borderRadius: Theme.borderRadius.lg,
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: 'rgba(0,0,0,0.06)',
    backgroundColor: '#fff',
    overflow: 'hidden',
  },
  widgetIcon: {
    fontSize: 24,
    lineHeight: 26,
    textAlign: 'center',
    textAlignVertical: 'center',
    color: Theme.colors.textPrimary,
  },
  widgetTitle: {
    fontSize: 18,
    fontFamily: Theme.typography.fontFamily.bold,
    fontWeight: '700',
    color: Theme.colors.textPrimary,
    flex: 1,
  },
  widgetText: {
    color: Theme.colors.textPrimary,
  },
  widgetItems: {
    gap: Theme.spacing.md,
  },
  widgetItem: {
    flexDirection: 'row',
    gap: Theme.spacing.md,
    alignItems: 'flex-start',
  },
  widgetNumber: {
    width: 24,
    height: 24,
    borderRadius: 12,
    justifyContent: 'center',
    alignItems: 'center',
  },
  widgetNumberText: {
    fontSize: 12,
    color: '#fff',
    fontFamily: Theme.typography.fontFamily.semiBold,
    fontWeight: '600',
  },
  widgetItemText: {
    flex: 1,
    fontSize: 15,
    color: Theme.colors.textPrimary,
    lineHeight: 22,
    paddingTop: 2,
  },
  engagementSection: {
    flexDirection: 'row',
    gap: Theme.spacing.md,
    marginBottom: Theme.spacing.xl,
  },
  engagementButton: {
    flex: 1,
    height: 52,
    borderRadius: Theme.borderRadius.lg,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: Theme.spacing.sm,
    backgroundColor: Theme.colors.surface,
    borderWidth: 1,
    borderColor: 'rgba(0,0,0,0.12)',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 4,
    elevation: 2,
  },
  engagementButtonSaved: {
    backgroundColor: Theme.colors.primary500,
    borderColor: Theme.colors.primary500,
  },
  engagementText: {
    fontSize: 15,
    fontFamily: Theme.typography.fontFamily.medium,
    color: Theme.colors.textPrimary,
    fontWeight: '500',
  },
  bookReferenceShadow: {
    backgroundColor: 'transparent',
    borderRadius: Theme.borderRadius.xl,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 8,
    elevation: 2,
    marginBottom: Theme.spacing.xl,
  },
  bookReference: {
    borderRadius: Theme.borderRadius.xl,
    padding: Theme.spacing.lg,
    flexDirection: 'row',
    gap: Theme.spacing.md,
    borderWidth: 1,
    borderColor: '#fcd34d',
  },
  bookCoverShadow: {
    backgroundColor: '#fff',
    borderRadius: Theme.borderRadius.sm,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.15,
    shadowRadius: 4,
    elevation: 2,
    alignSelf: 'flex-start',
  },
  bookCover: {
    width: 48,
    height: 72,
    borderRadius: Theme.borderRadius.sm,
  },
  bookInfo: {
    flex: 1,
    justifyContent: 'center',
  },
  bookLabel: {
    fontSize: 11,
    color: Theme.colors.textSecondary,
    marginBottom: 4,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  bookTitle: {
    fontSize: 14,
    color: Theme.colors.textPrimary,
    lineHeight: 20,
    fontFamily: Theme.typography.fontFamily.semiBold,
    fontWeight: '600',
  },
  bookAuthor: {
    fontSize: 12,
    color: Theme.colors.textSecondary,
    marginTop: 2,
  },
  lockOverlay: {
    ...StyleSheet.absoluteFillObject,
    justifyContent: 'center',
    alignItems: 'center',
  },
  lockBackdrop: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: 'rgba(0,0,0,0.55)',
  },
  lockCard: {
    width: '85%',
    maxWidth: 400,
    backgroundColor: Theme.colors.surface,
    borderRadius: Theme.borderRadius.lg,
    padding: Theme.spacing.lg,
    elevation: 6,
    shadowColor: '#000',
    shadowOpacity: 0.15,
    shadowRadius: 12,
    shadowOffset: { width: 0, height: 6 },
  },
  lockedPageContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: Theme.spacing.xxl,
    backgroundColor: Theme.colors.background,
  },
  lockedContent: {
    alignItems: 'center',
    maxWidth: 400,
  },
});
